import { useNavigate, useSearchParams } from 'react-router-dom';

export const useResetPasswordNavigation = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const email = params.get('email') ?? '';
  const token = params.get('token')?.replaceAll(' ', '+') ?? '';

  const goToRequest = () => navigate(`/reset-password/request?email=${email}`);

  const goToRequestAgain = (submitEmail: string) =>
    navigate(`/reset-password/resend?email=${submitEmail ?? email}`);

  const goToConfirmation = () =>
    navigate(`/reset-password/confirmation?email=${email}`);

  const goToLogin = () => navigate(`/login?email=${email}`);

  return {
    email,
    token,
    goToRequest,
    goToRequestAgain,
    goToConfirmation,
    goToLogin,
  };
};
